<template>
  <v-select
    v-model="selected"
    :items="selectItems"
    :label="label"
    light
    dense
    outlined
  />
</template>

<script>
import formModal from '@/mixins/form-modal';
import { mapState } from 'vuex';

export default {
  name: 'SelectFilter',
  mixins: [
    formModal,
  ],
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    selectItems: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      message: '',
    };
  },
  computed: {
    ...mapState('misc', [
      'formModal',
    ]),
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .v-input {
    width: 287px !important;
  }
</style>
